import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;

export default {
    async getNotificationTypes() {
        return Axios.get(`${baseURL}actor/notification-type`).then(
            response => response.data.response
        );
    },
    async getUserPreferences(encodedId) {
        return Axios.get(`${baseURL}actor/user-preferences/${encodedId}`).then(
            response => response.data.response
        );
    },
    async saveUserPreferences(encodedId, param) {
        return Axios.post(
            `${baseURL}actor/user-preferences/${encodedId}`,
            param
        ).then(response => response.data.response);
    },
    async getTaskGlobalNotiSettings() {
        return Axios.get(`${baseURL}account/notification-setting`).then(
            response => response.data.response
        );
    },
    async updateGlobalNotiSettings(param) {
        return Axios.post(`${baseURL}account/notification-setting`, param).then(
            response => response.data.response
        );
    }
};
